import { Box, IconButton, Modal, Tooltip, Typography } from '@mui/material';
import React, { useState } from 'react';
import UserAvatar from '@pages/common/chat/components/UserAvatar';
import SchoolIcon from '@mui/icons-material/School';

// for future use
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';

import { useGetChatProfileQuery } from '@store/feature/chat/chatApi';
import PrivateKnowledgeBase from '../../../pages/common/chat/components/privateKnowledgeBase/PrivateKnowledgeBaseModal';

const TopBar = ({ profile }) => {
    const { data: currentLoggedInUser } = useGetChatProfileQuery();

    // knowledge base modal
    const [showKnowledgeBaseModal, setShowKnowledgeBaseModal] = useState(false);
    const handleShowKnowledgeBaseModal = () => {
        setShowKnowledgeBaseModal(!showKnowledgeBaseModal);
    };
    const handleKnowledgeBaseModalClose = () => {
        setShowKnowledgeBaseModal(false);
    };

    return (
        <>
            <Modal
                open={showKnowledgeBaseModal}
                onClose={handleKnowledgeBaseModalClose}
            >
                <PrivateKnowledgeBase
                    handleClose={handleKnowledgeBaseModalClose}
                    isKnowledgeBase={true}
                />
            </Modal>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    flex: 1,
                    justifyContent: 'space-between',
                    borderBottom: '2px solid #ccc',
                    p: '8px 10px'
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        gap: '10px',
                        alignItems: 'center'
                    }}
                >
                    <UserAvatar
                        imgSource={profile?.image_url}
                        fullName={profile?.fullname}
                        isActive={
                            profile?.status === 'active' ||
                            profile?.uuid === currentLoggedInUser?.uuid
                        }
                    />
                    <Typography
                        variant="body2"
                        sx={{
                            color: '#000',
                            fontWeight: 'medium',
                            padding: '0',
                            margin: '0'
                        }}
                    >
                        {profile?.fullname}
                    </Typography>
                </Box>
                {profile?.fullname === 'Chatbot' && (
                    <Tooltip title="Private Knowledge Base">
                        <IconButton>
                            <SchoolIcon
                                sx={{
                                    fontSize: '1.5rem',
                                    cursor: 'pointer'
                                }}
                                onClick={handleShowKnowledgeBaseModal}
                            />
                        </IconButton>
                    </Tooltip>
                )}
            </Box>
            {/* <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        marginLeft: 'auto',
                    }}
                >
                    <IconButton>
                        <LocalPhoneOutlinedIcon />
                    </IconButton>
                    <IconButton>
                        <VideocamOutlinedIcon />
                    </IconButton>
                </Box> */}
        </>
    );
};

export default TopBar;
